
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.338 17.885h-1.2v-5.793c0-.037-.006-.073-.011-.11a.96.96 0 00-.233-.634L33.254.335l-.008-.007a.965.965 0 00-.195-.163c-.021-.015-.042-.026-.064-.039a1.026 1.026 0 00-.194-.081l-.052-.017A.993.993 0 0032.516 0H8.824C7.742 0 6.863.88 6.863 1.96v15.924h-1.2a2.802 2.802 0 00-2.803 2.803V35.26a2.803 2.803 0 002.802 2.803h1.2v9.976c0 1.081.88 1.961 1.962 1.961h32.352c1.081 0 1.961-.88 1.961-1.96v-9.977h1.2a2.803 2.803 0 002.803-2.802V20.687a2.803 2.803 0 00-2.802-2.802zM8.824 1.96h22.711v10.032c0 .542.44.98.98.98h8.661v4.912H8.824V1.961zm28.074 31.08h-2.37l-.159-4.218a126.99 126.99 0 01-.096-4.529h-.046a61.13 61.13 0 01-1.195 4.268l-1.303 4.3h-1.893l-1.146-4.267a51.88 51.88 0 01-.971-4.3h-.032c-.064 1.488-.112 3.188-.19 4.561l-.192 4.186h-2.243l.684-11.02h3.23l1.05 3.679c.334 1.275.668 2.649.907 3.94h.047c.304-1.275.668-2.73 1.019-3.956l1.145-3.663h3.166l.588 11.02zm-21.063-8.927v-2.093h8.24v2.093h-2.927v8.927h-2.434v-8.927h-2.879zm-7.72 4.317v4.61H5.684v-11.02h2.433v4.235h3.994v-4.235h2.419v11.02h-2.42v-4.61H8.117zm33.061 19.077H8.825v-9.445h32.352v9.445zm4.284-14.467h-6.698v-11.02h2.434v8.927h4.264v2.093z","fill":"#fff"}})])
          )
        }
      }
    